var _defs, _path, _path2, _path3, _g, _g2, _path4, _g3, _path5, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g14, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _line, _path52, _path53, _path54, _path55, _g15, _path56, _path57, _path58, _path59, _g16, _g17, _g18, _path60, _path61, _g19, _g20, _g21, _path62, _g22, _path63, _path64, _path65, _g23, _path66, _path67, _path68;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStreetMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 213.755 192.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84979",
    "data-name": "1-Caminho 84979",
    d: "M211.552,157.35v86.577L198.635,236.6V150.425Z",
    transform: "translate(-198.635 -150.425)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1-linear-gradient",
    x1: -2.245,
    y1: 1.479,
    x2: -2.233,
    y2: 1.479,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25231f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#33302a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#46423a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84981",
    "data-name": "1-Caminho 84981",
    d: "M188.083,88.06l-.909.994-12.917-7.724-5.1-14.47.053.07Z",
    transform: "translate(-169.156 -66.859)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1-linear-gradient-2",
    x1: -1.548,
    y1: 6.892,
    x2: -1.539,
    y2: 6.892,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25231f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84988",
    "data-name": "1-Caminho 84988",
    d: "M187.116.472,168.885,11.035a.6.6,0,0,0-.3.611l.094.255.019.028L187.61,33.1a.612.612,0,0,0,.771.119l18.281-11.032a.48.48,0,0,0,.139-.717v0L187.88.592a.611.611,0,0,0-.764-.12",
    transform: "translate(-168.58 -0.388)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1-linear-gradient-3",
    x1: -0.456,
    y1: 3.479,
    x2: -0.453,
    y2: 3.479,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8259",
    "data-name": "1-Ret\\xE2ngulo 8259",
    width: 19.731,
    height: 21.993,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8260",
    "data-name": "1-Ret\\xE2ngulo 8260",
    width: 38.329,
    height: 32.915,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8261",
    "data-name": "1-Ret\\xE2ngulo 8261",
    width: 19.698,
    height: 21.958,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8262",
    "data-name": "1-Ret\\xE2ngulo 8262",
    width: 19.65,
    height: 21.903,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8263",
    "data-name": "1-Ret\\xE2ngulo 8263",
    width: 19.637,
    height: 21.893,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8264",
    "data-name": "1-Ret\\xE2ngulo 8264",
    width: 19.624,
    height: 21.873,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8265",
    "data-name": "1-Ret\\xE2ngulo 8265",
    width: 19.581,
    height: 21.831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8266",
    "data-name": "1-Ret\\xE2ngulo 8266",
    width: 19.557,
    height: 21.797,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85009",
    "data-name": "1-Caminho 85009",
    d: "M314.21,173l-7.913,4.566a.364.364,0,0,0-.186.32v3.027a.115.115,0,0,0,.016.057.112.112,0,0,0,.154.038l7.952-4.592a.361.361,0,0,0,.185-.317v-2.985a.137.137,0,0,0-.019-.065.138.138,0,0,0-.189-.05",
    transform: "translate(-306.111 -172.977)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1-linear-gradient-4",
    x1: -6.381,
    y1: 16.7,
    x2: -6.36,
    y2: 16.7,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25231f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85023",
    "data-name": "1-Caminho 85023",
    d: "M293.04,321.114c-.537.289-.888,1-.758,1.3a.953.953,0,0,0,1.251.4,1.07,1.07,0,0,0,.619-1.2.816.816,0,0,0-.764-.594.73.73,0,0,0-.349.091",
    transform: "translate(-292.255 -321.023)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "1-radial-gradient",
    cx: 0.662,
    cy: 0.51,
    r: 0.338,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7e85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#777a81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#5b5d61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#434447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    stopColor: "#303133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#232424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85030",
    "data-name": "1-Caminho 85030",
    d: "M306.211,250.939l0,2.627a.12.12,0,0,0,.175.106l9.35-5.014.033-2.968Z",
    transform: "translate(-306.211 -245.69)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1-linear-gradient-5",
    x1: -4.155,
    y1: 9.979,
    x2: -4.141,
    y2: 9.979,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#444038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#32302a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#282621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25231f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8274",
    "data-name": "1-Ret\\xE2ngulo 8274",
    width: 9.539,
    height: 5.699,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85033",
    "data-name": "1-Caminho 85033",
    d: "M315.466,211.994a.1.1,0,0,0-.037,0s-.009,0-.016,0,0,0,0,0l-.025.007c-.009.007-.019.009-.021.012l-5.127,2.935-3.877,2.207a.765.765,0,0,0-.241.446l0,.086,9.536-5.172,0-.33a.193.193,0,0,0-.184-.2",
    transform: "translate(-306.111 -211.992)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1-linear-gradient-6",
    x1: -4.712,
    y1: 13.782,
    x2: -4.697,
    y2: 13.782,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25231f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8276",
    "data-name": "1-Ret\\xE2ngulo 8276",
    width: 9.509,
    height: 5.483,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85034",
    "data-name": "1-Caminho 85034",
    d: "M315.706,243.562v.265l-9.509,5.219,0-.312Z",
    transform: "translate(-306.197 -243.562)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1-linear-gradient-7",
    x1: -4.771,
    y1: 13.497,
    x2: -4.756,
    y2: 13.497,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8277",
    "data-name": "1-Ret\\xE2ngulo 8277",
    width: 0.358,
    height: 3.098,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85039",
    "data-name": "1-Caminho 85039",
    d: "M279.624,417.052v40.817l14.8-8.421V408.427Z",
    transform: "translate(-279.624 -408.427)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1-linear-gradient-8",
    x1: -2.265,
    y1: 1.861,
    x2: -2.256,
    y2: 1.861,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25231f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2e2c27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#3f3c34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#49453d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8280",
    "data-name": "1-Ret\\xE2ngulo 8280",
    width: 0.08,
    height: 0.719,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8281",
    "data-name": "1-Ret\\xE2ngulo 8281",
    width: 2.836,
    height: 4.557,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8282",
    "data-name": "1-Ret\\xE2ngulo 8282",
    width: 3.899,
    height: 2.84,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8283",
    "data-name": "1-Ret\\xE2ngulo 8283",
    width: 1.063,
    height: 0.976,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8284",
    "data-name": "1-Ret\\xE2ngulo 8284",
    width: 3.096,
    height: 2.144,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1-clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8285",
    "data-name": "1-Ret\\xE2ngulo 8285",
    width: 1.063,
    height: 1.012,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16744",
    "data-name": "1-Grupo 16744",
    transform: "translate(-432.445 -17.316)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84933",
    "data-name": "1-Caminho 84933",
    d: "M373.525,633.883l-.049,17.246-79.11-47.012.049-17.246Z",
    transform: "translate(138.579 -441.953)",
    fill: "#082143",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84934",
    "data-name": "1-Caminho 84934",
    d: "M10609.009,936.235l-133.752,77.278-79.45-47.621,139.241-71.057Z",
    transform: "translate(-9962.855 -820.979)",
    fill: "#000a33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84935",
    "data-name": "1-Caminho 84935",
    d: "M769.54,386.305l-.048,16.925L635.444,480.435l.048-16.925Z",
    transform: "translate(-123.34 -271.26)",
    fill: "#001b3d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16608",
    "data-name": "1-Grupo 16608",
    transform: "translate(432.947 65.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84576",
    "data-name": "1-Caminho 84576",
    d: "M1145.175,823.491l-132.614,75.854-30.669-18.329L1114.5,805.729Z",
    transform: "translate(-981.893 -805.729)",
    fill: "#003090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84577",
    "data-name": "1-Caminho 84577",
    d: "M1114.931,818.926,991.015,891.167l-24.142-14,126.092-70.333Z",
    transform: "translate(-959.908 -801.683)",
    fill: "#001745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84575",
    "data-name": "1-Caminho 84575",
    d: "M1157.11,817.832v-4.552l-132.573,75.792v4.741Z",
    transform: "translate(-993.862 -795.52)",
    fill: "#0553c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16743",
    "data-name": "1-Grupo 16743",
    transform: "translate(5693 7608.316)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16724",
    "data-name": "1-Grupo 16724",
    transform: "translate(-5228.072 -7564.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16639",
    "data-name": "1-Grupo 16639",
    clipPath: "url(#1-clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8255",
    "data-name": "1-Ret\\xE2ngulo 8255",
    width: 14.886,
    height: 93.754,
    transform: "matrix(1, -0.021, 0.021, 1, -1.972, 0.042)",
    fill: "url(#1-linear-gradient)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85105",
    "data-name": "1-Caminho 85105",
    d: "M198.75,150.653l12.655,6.78V243.7l-12.655-7.18Zm-.132-.223V236.6l12.917,7.33V157.355Z",
    transform: "translate(-5426.693 -7715.376)",
    fill: "#221f20"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16725",
    "data-name": "1-Grupo 16725",
    transform: "translate(-5233.178 -7579.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16641",
    "data-name": "1-Grupo 16641",
    clipPath: "url(#1-clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8256",
    "data-name": "1-Ret\\xE2ngulo 8256",
    width: 18.926,
    height: 22.194,
    transform: "translate(0 0)",
    fill: "url(#1-linear-gradient-2)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85106",
    "data-name": "1-Caminho 85106",
    d: "M169.477,67.488l18.395,20.59-.754.827-12.785-7.643Zm-.355-.607,5.1,14.47,12.917,7.724.909-.994L169.17,66.954l-.054-.069Z",
    transform: "translate(-5402.3 -7646.298)",
    fill: "#221f20"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16726",
    "data-name": "1-Grupo 16726",
    transform: "translate(-5215.157 -7569.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16738",
    "data-name": "1-Grupo 16738",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84983",
    "data-name": "1-Caminho 84983",
    d: "M287.447,130.766c-1.282.748-2,1.2-2,1.2l-10.205,5.907a3.68,3.68,0,0,1-1.9.374l-.135-.056.909-.994a.612.612,0,0,0,.771.119l18.282-11.032-4.676,3.566s.232.166-1.049.918",
    transform: "translate(-273.21 -126.275)",
    fill: "#36332e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84984",
    "data-name": "1-Caminho 84984",
    d: "M291.13,127.628l-2.72,2.075a.132.132,0,0,0-.054.107.162.162,0,0,0,.01.054c-.026.053-.17.271-.994.752-1.267.742-1.994,1.2-2,1.2l-10.192,5.9a4.641,4.641,0,0,1-1.516.4,1,1,0,0,1-.229-.022l.688-.751a.727.727,0,0,0,.446.147.762.762,0,0,0,.382-.1l16.177-9.762m2.035-1.383-18.282,11.032a.639.639,0,0,1-.314.085.6.6,0,0,1-.458-.2l-.909.994.135.056a1.213,1.213,0,0,0,.326.041,4.581,4.581,0,0,0,1.557-.393l10.217-5.928s.717-.449,2-1.2,1.051-.922,1.051-.922l4.676-3.566Z",
    transform: "translate(-273.203 -126.242)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84985",
    "data-name": "1-Caminho 84985",
    d: "M289.137,146.855s.229.17-1.048.922-2,1.2-2,1.2l-10.206,5.907a3.677,3.677,0,0,1-1.9.374,1.344,1.344,0,0,1,.912,1.371l.069,44.158,14.8-8.617V148.006s.079-1-.631-1.151m.135,45.094-13.389,7.865V156.462L289,148.894a.184.184,0,0,1,.276.159Z",
    transform: "translate(-273.852 -143.285)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84986",
    "data-name": "1-Caminho 84986",
    d: "M273.21,240.054h0l1.116.271-.006,40.855-1.11-.66V194.679s.089.1.135.116a1.368,1.368,0,0,1,.98,1.4v44.129Z",
    transform: "translate(-273.209 -182.826)",
    fill: "#25231f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84987",
    "data-name": "1-Caminho 84987",
    d: "M273.343,194.94a1.218,1.218,0,0,1,.852,1.236v43.978l-.852-.2Zm0,45.283.852.2-.006,40.516-.846-.5V240.224m-.132-45.545v45.375l1.116.271v-44.13a1.368,1.368,0,0,0-.981-1.4c-.047-.013-.135-.116-.135-.116m0,45.375v40.465l1.112.622,0-40.817-1.116-.271Z",
    transform: "translate(-273.21 -182.826)",
    fill: "#221f20"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16727",
    "data-name": "1-Grupo 16727",
    transform: "translate(-5233.277 -7590.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16645",
    "data-name": "1-Grupo 16645",
    clipPath: "url(#1-clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8258",
    "data-name": "1-Ret\\xE2ngulo 8258",
    width: 50.585,
    height: 49.673,
    transform: "translate(-16.056 12.602) rotate(-38.179)",
    fill: "url(#1-linear-gradient-3)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16728",
    "data-name": "1-Grupo 16728",
    transform: "translate(-5233.341 -7591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16740",
    "data-name": "1-Grupo 16740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84989",
    "data-name": "1-Caminho 84989",
    d: "M187.763,33.051a.679.679,0,0,1-.507-.229L168.346,11.65l-.025-.038-.1-.267a.667.667,0,0,1,.327-.692L186.781.089a.688.688,0,0,1,.841.129L206.544,21.1a.491.491,0,0,1,.116.415.58.58,0,0,1-.27.406L188.109,32.951a.7.7,0,0,1-.346.1M187.121.136a.534.534,0,0,0-.274.076L168.616,10.773a.542.542,0,0,0-.268.547l.1.262,18.9,21.155a.542.542,0,0,0,.688.1l18.285-11.029a.452.452,0,0,0,.208-.306.371.371,0,0,0-.089-.306L187.529.321a.551.551,0,0,0-.408-.186Z",
    transform: "translate(-168.213 0)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16649",
    "data-name": "1-Grupo 16649",
    transform: "translate(2.533 9.447)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16648",
    "data-name": "1-Grupo 16648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16647",
    "data-name": "1-Grupo 16647",
    clipPath: "url(#1-clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84990",
    "data-name": "1-Caminho 84990",
    d: "M202.5,76.542a.063.063,0,0,1-.05-.022l-19.6-21.859a.068.068,0,0,1,0-.094.065.065,0,0,1,.092,0l0,0,19.6,21.859a.068.068,0,0,1,0,.094.076.076,0,0,1-.044.016",
    transform: "translate(-182.837 -54.549)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16652",
    "data-name": "1-Grupo 16652",
    transform: "translate(0.066 0.074)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16651",
    "data-name": "1-Grupo 16651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16650",
    "data-name": "1-Grupo 16650",
    clipPath: "url(#1-clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84991",
    "data-name": "1-Caminho 84991",
    d: "M187.438.558h0a.477.477,0,0,1,.356.157l18.922,20.879a.321.321,0,0,1,.069.251.4.4,0,0,1-.176.264L188.325,33.139a.493.493,0,0,1-.245.069.47.47,0,0,1-.355-.16L168.819,11.888v-.006l-.086-.229a.475.475,0,0,1,.236-.465L187.2.628a.454.454,0,0,1,.238-.066m0-.132a.647.647,0,0,0-.306.082L168.9,11.075a.6.6,0,0,0-.3.611l.094.255.019.028,18.911,21.171a.606.606,0,0,0,.458.2.641.641,0,0,0,.315-.085l18.282-11.033a.478.478,0,0,0,.138-.717L187.9.635a.607.607,0,0,0-.453-.2Z",
    transform: "translate(-168.597 -0.43)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16655",
    "data-name": "1-Grupo 16655",
    transform: "translate(4.898 8.105)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16654",
    "data-name": "1-Grupo 16654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16653",
    "data-name": "1-Grupo 16653",
    clipPath: "url(#1-clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84992",
    "data-name": "1-Caminho 84992",
    d: "M216.128,68.757a.082.082,0,0,1-.05-.022L196.511,46.91a.066.066,0,1,1,.1-.088l19.566,21.823a.065.065,0,0,1,0,.092l0,0a.06.06,0,0,1-.041.019",
    transform: "translate(-196.494 -46.8)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16658",
    "data-name": "1-Grupo 16658",
    transform: "translate(7.247 6.744)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16657",
    "data-name": "1-Grupo 16657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16656",
    "data-name": "1-Grupo 16656",
    clipPath: "url(#1-clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84993",
    "data-name": "1-Caminho 84993",
    d: "M229.639,60.844a.059.059,0,0,1-.047-.022L210.068,39.047a.067.067,0,0,1,.1-.088L229.69,60.734a.066.066,0,0,1,0,.093h0a.076.076,0,0,1-.044.016",
    transform: "translate(-210.056 -38.941)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16661",
    "data-name": "1-Grupo 16661",
    transform: "translate(9.584 5.371)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16660",
    "data-name": "1-Grupo 16660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16659",
    "data-name": "1-Grupo 16659",
    clipPath: "url(#1-clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84994",
    "data-name": "1-Caminho 84994",
    d: "M243.124,52.9a.077.077,0,0,1-.05-.022l-19.5-21.76a.07.07,0,0,1,0-.094.067.067,0,0,1,.094.005h0l19.507,21.756a.068.068,0,0,1-.006.095.063.063,0,0,1-.041.019",
    transform: "translate(-223.551 -31.011)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16664",
    "data-name": "1-Grupo 16664",
    transform: "translate(11.917 3.995)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16663",
    "data-name": "1-Grupo 16663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16662",
    "data-name": "1-Grupo 16662",
    clipPath: "url(#1-clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84995",
    "data-name": "1-Caminho 84995",
    d: "M256.578,44.939a.062.062,0,0,1-.05-.021L237.038,23.18a.066.066,0,0,1,0-.093l0,0a.07.07,0,0,1,.095,0l19.49,21.741a.068.068,0,0,1-.006.094.077.077,0,0,1-.044.019",
    transform: "translate(-237.021 -23.067)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16667",
    "data-name": "1-Grupo 16667",
    transform: "translate(14.272 2.637)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16666",
    "data-name": "1-Grupo 16666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16665",
    "data-name": "1-Grupo 16665",
    clipPath: "url(#1-clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84996",
    "data-name": "1-Caminho 84996",
    d: "M270.131,37.055a.062.062,0,0,1-.05-.022l-19.449-21.7a.066.066,0,1,1,.1-.088l19.451,21.7a.068.068,0,0,1-.007.094.072.072,0,0,1-.043.016",
    transform: "translate(-250.615 -15.224)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16670",
    "data-name": "1-Grupo 16670",
    transform: "translate(16.627 1.291)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16669",
    "data-name": "1-Grupo 16669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16668",
    "data-name": "1-Grupo 16668",
    clipPath: "url(#1-clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84997",
    "data-name": "1-Caminho 84997",
    d: "M283.705,29.25a.077.077,0,0,1-.05-.022L264.233,7.568a.066.066,0,0,1,0-.093l0,0a.061.061,0,0,1,.086,0l0,0,19.423,21.659a.07.07,0,0,1,0,.095.063.063,0,0,1-.049.023",
    transform: "translate(-264.216 -7.453)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84998",
    "data-name": "1-Caminho 84998",
    d: "M218.767,187.986,215.1,185.91a1.585,1.585,0,0,0-2.365,1.38v5.57c0,3.145,2.233,6.063,4.968,7.62a2.03,2.03,0,0,0,3.035-1.767v-7.356a4.3,4.3,0,0,0-1.97-3.371",
    transform: "translate(-205.023 -153.542)",
    fill: "#113b99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84999",
    "data-name": "1-Caminho 84999",
    d: "M224.689,199.351a1.848,1.848,0,0,1-.446,1.475q-.452.349-1.3-.129l-1.663-.925v2.56l-1.038-.586v-7.063l2.818,1.575a3.258,3.258,0,0,1,1.629,3.092m-3.406-.721,1.6.89q.382.217.569.057c.125-.107.186-.362.186-.764a2.186,2.186,0,0,0-.17-.922,1.237,1.237,0,0,0-.531-.566l-1.654-.922Z",
    transform: "translate(-211.231 -160.966)",
    fill: "#f2f8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85000",
    "data-name": "1-Caminho 85000",
    d: "M230.648,239c.7-.456,1.931.188,2.742,1.438s.9,2.634.194,3.09-1.931-.188-2.742-1.438-.9-2.634-.194-3.09",
    transform: "translate(-219.442 -197.484)",
    fill: "#f3d638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85001",
    "data-name": "1-Caminho 85001",
    d: "M231.177,239.107h0a2.884,2.884,0,0,1,1.994,1.462,3.711,3.711,0,0,1,.623,1.717,1.062,1.062,0,0,1-.349,1.007.688.688,0,0,1-.382.1,2.885,2.885,0,0,1-1.993-1.463,3.7,3.7,0,0,1-.623-1.717,1.061,1.061,0,0,1,.349-1.007.69.69,0,0,1,.382-.1m0-.267a.945.945,0,0,0-.525.148c-.7.458-.616,1.84.2,3.091a3.077,3.077,0,0,0,2.217,1.585.949.949,0,0,0,.526-.148c.7-.459.617-1.84-.2-3.092a3.081,3.081,0,0,0-2.217-1.585Z",
    transform: "translate(-219.445 -197.473)",
    fill: "#f3d638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85002",
    "data-name": "1-Caminho 85002",
    d: "M284.591,201.979l3.467,6.794-.281,26.176-3.22,10.378Z",
    transform: "translate(-264.407 -166.998)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85003",
    "data-name": "1-Caminho 85003",
    d: "M284.623,208.542l-.031-.009a.067.067,0,0,1-.034-.057V165.12a.067.067,0,0,1,.034-.06l13.385-7.724a.064.064,0,0,1,.066,0,.068.068,0,0,1,.034.057v43.214a.068.068,0,0,1-.034.06l-13.386,7.866Zm.069-43.381v43.2l13.249-7.787v-43.06Z",
    transform: "translate(-264.407 -130.08)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85004",
    "data-name": "1-Caminho 85004",
    d: "M360.391,193.275l.251,8.184V158.4l-.2,8.137Z",
    transform: "translate(-327.107 -130.966)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85005",
    "data-name": "1-Caminho 85005",
    d: "M287.629,365.666l10.22-5.562.165,8.133-13.485,7.852a.032.032,0,0,1-.047-.037Z",
    transform: "translate(-264.344 -297.737)",
    fill: "#3a3a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85006",
    "data-name": "1-Caminho 85006",
    d: "M314.434,384.924l6.389-3.466-.006,3.284-6.383,3.455Z",
    transform: "translate(-289.11 -315.393)",
    fill: "#464748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85007",
    "data-name": "1-Caminho 85007",
    d: "M315.051,385.466l6.174-3.349-.007,3.173-6.169,3.338Z",
    transform: "translate(-289.619 -315.938)",
    fill: "none",
    stroke: "#221f20",
    strokeWidth: 1.297
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85008",
    "data-name": "1-Caminho 85008",
    d: "M298.46,166.983v-8.754a.051.051,0,0,0-.076-.044l-13.238,7.641a.091.091,0,0,0-.036.119l3.363,6.766",
    transform: "translate(-264.856 -130.783)",
    fill: "#2d2c2c"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16729",
    "data-name": "1-Grupo 16729",
    transform: "translate(-5209.458 -7561.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16673",
    "data-name": "1-Grupo 16673",
    clipPath: "url(#1-clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8268",
    "data-name": "1-Ret\\xE2ngulo 8268",
    width: 8.308,
    height: 8.059,
    transform: "translate(-0.001 0)",
    fill: "url(#1-linear-gradient-4)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16730",
    "data-name": "1-Grupo 16730",
    transform: "translate(-5212.062 -7561.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16737",
    "data-name": "1-Grupo 16737",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85010",
    "data-name": "1-Caminho 85010",
    d: "M305.9,180.755a.177.177,0,0,1-.18-.178v-3.026a.439.439,0,0,1,.218-.381l7.913-4.563a.208.208,0,0,1,.311.176v2.985a.435.435,0,0,1-.218.378l-7.955,4.592a.173.173,0,0,1-.09.019m8.054-8.045-.035.009-7.911,4.566a.3.3,0,0,0-.15.262v3.026a.042.042,0,0,0,.019.038.043.043,0,0,0,.044,0l7.955-4.592a.3.3,0,0,0,.15-.259v-2.985a.067.067,0,0,0-.037-.061Z",
    transform: "translate(-303.188 -172.579)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85011",
    "data-name": "1-Caminho 85011",
    d: "M306.441,195.333l.014.617,8.169-4.681v-.313Z",
    transform: "translate(-303.78 -187.773)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85012",
    "data-name": "1-Caminho 85012",
    d: "M317.03,225.706l.02.145c.009.067.128.093.215.048l.733-.381a.092.092,0,0,0,.06-.086l-.02-.145c-.009-.067-.128-.093-.215-.048l-.732.381a.092.092,0,0,0-.06.086",
    transform: "translate(-312.534 -216.1)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85013",
    "data-name": "1-Caminho 85013",
    d: "M319.61,225.568l.065.075c.006.042.066.061.109.034l.374-.186c.02-.013.019-.073.016-.093l-.013-.092c-.006-.042-.13-.054-.173-.027l-.357.168c-.02.013-.024.1-.022.121",
    transform: "translate(-314.668 -216.14)",
    fill: "#8fb564"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85014",
    "data-name": "1-Caminho 85014",
    d: "M303.815,208.6l-.256,26.237a.185.185,0,0,1-.1.163l-9.75,5.341a.109.109,0,0,1-.16-.1l.053-8.3a.884.884,0,0,0-.647-.852,2.5,2.5,0,0,1-.864-.43c-.737-.6-.823-2.525.251-3.69a3.638,3.638,0,0,1,.716-.6,1.235,1.235,0,0,0,.586-1.028l.07-11.035a.593.593,0,0,1,.3-.516l9.518-5.358a.187.187,0,0,1,.279.163",
    transform: "translate(-291.458 -202.205)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85015",
    "data-name": "1-Caminho 85015",
    d: "M303.815,208.6l-.256,26.237a.185.185,0,0,1-.1.163l-9.75,5.341a.109.109,0,0,1-.16-.1l.053-8.3a.884.884,0,0,0-.647-.852,2.5,2.5,0,0,1-.864-.43c-.737-.6-.823-2.525.251-3.69a3.638,3.638,0,0,1,.716-.6,1.235,1.235,0,0,0,.586-1.028l.07-11.035a.593.593,0,0,1,.3-.516l9.518-5.358A.187.187,0,0,1,303.815,208.6Z",
    transform: "translate(-291.458 -202.205)",
    fill: "none",
    stroke: "#2d2d2d",
    strokeWidth: 1.343
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85016",
    "data-name": "1-Caminho 85016",
    d: "M336.514,326.508l3.751-2.1-.007,5.851-3.745,2.088Z",
    transform: "translate(-328.643 -298.114)",
    fill: "#2d2f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85017",
    "data-name": "1-Caminho 85017",
    d: "M334.941,286.607c-.241.412-.638.624-.892.474s-.268-.593-.035-1.007.638-.621.888-.478.271.6.038,1.011",
    transform: "translate(-326.44 -265.985)",
    fill: "#f3d638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85018",
    "data-name": "1-Caminho 85018",
    d: "M334.273,286.3a1.742,1.742,0,0,1-.335.458.773.773,0,0,1-.269.162.476.476,0,0,1-.361-.031.515.515,0,0,1-.234-.286.843.843,0,0,1-.035-.327,1.389,1.389,0,0,1,.207-.568,1.342,1.342,0,0,1,.414-.418.591.591,0,0,1,.6-.055.543.543,0,0,1,.193.548,1.6,1.6,0,0,1-.182.52m-.023-.013a.941.941,0,0,0,.145-.51.465.465,0,0,0-.2-.419.418.418,0,0,0-.423.084,1.09,1.09,0,0,0-.317.378,1.023,1.023,0,0,0-.121.469.406.406,0,0,0,.125.344.431.431,0,0,0,.4-.01.909.909,0,0,0,.4-.337Z",
    transform: "translate(-325.768 -265.671)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85019",
    "data-name": "1-Caminho 85019",
    d: "M295.121,313.757a2.664,2.664,0,0,1-3.492.227c-.736-.595-.821-2.525.253-3.69s2.891-1.5,3.632-.9.68,3.2-.394,4.363",
    transform: "translate(-291.076 -285.459)",
    fill: "#2d2f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85020",
    "data-name": "1-Caminho 85020",
    d: "M294.959,317.211a2.229,2.229,0,0,1-2.9.215c-.612-.493-.447-2.022.445-2.985a2.243,2.243,0,0,1,2.806-.627c.616.493.544,2.435-.348,3.4",
    transform: "translate(-291.584 -289.127)",
    fill: "#1d1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85021",
    "data-name": "1-Caminho 85021",
    d: "M294.959,317.211a2.229,2.229,0,0,1-2.9.215c-.612-.493-.447-2.022.445-2.985a2.243,2.243,0,0,1,2.806-.627C295.922,314.306,295.85,316.248,294.959,317.211Z",
    transform: "translate(-291.584 -289.127)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeWidth: 1.007
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85022",
    "data-name": "1-Caminho 85022",
    d: "M294.439,320.367a1.767,1.767,0,0,1-2.269.2c-.512-.388-.336-1.3.392-2.034s1.735-1.02,2.25-.632.355,1.726-.373,2.462",
    transform: "translate(-291.738 -292.592)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16731",
    "data-name": "1-Grupo 16731",
    transform: "translate(-5211.858 -7535.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16677",
    "data-name": "1-Grupo 16677",
    clipPath: "url(#1-clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8270",
    "data-name": "1-Ret\\xE2ngulo 8270",
    width: 2.902,
    height: 2.903,
    transform: "translate(-1.089 0.71) rotate(-35.748)",
    fill: "url(#1-radial-gradient)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16732",
    "data-name": "1-Grupo 16732",
    transform: "translate(-5210.58 -7554.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16741",
    "data-name": "1-Grupo 16741",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "1-Linha_121",
    "data-name": "1-Linha 121",
    y2: 1.419,
    transform: "translate(0 19.121)",
    fill: "none",
    stroke: "#4d5151",
    strokeWidth: 0.671
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85024",
    "data-name": "1-Caminho 85024",
    d: "M338.949,363.97c-.09.153-.237.232-.332.176s-.1-.221-.013-.375.237-.231.331-.178.1.223.014.376",
    transform: "translate(-331.804 -337.324)",
    fill: "#65a7c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85025",
    "data-name": "1-Caminho 85025",
    d: "M339.983,364.138c-.045.077-.119.117-.167.089s-.05-.111-.006-.188.119-.116.166-.089.051.112.007.189",
    transform: "translate(-332.826 -337.624)",
    fill: "#aadff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85026",
    "data-name": "1-Caminho 85026",
    d: "M338.687,363.837a.66.66,0,0,1-.126.172.292.292,0,0,1-.1.061.179.179,0,0,1-.136-.012.2.2,0,0,1-.088-.108.316.316,0,0,1-.013-.123.523.523,0,0,1,.078-.214.506.506,0,0,1,.156-.158.223.223,0,0,1,.227-.021.2.2,0,0,1,.072.206.6.6,0,0,1-.068.2m-.009-.005a.355.355,0,0,0,.055-.192.175.175,0,0,0-.077-.158.158.158,0,0,0-.16.032.411.411,0,0,0-.119.143.386.386,0,0,0-.046.176.154.154,0,0,0,.047.13.163.163,0,0,0,.151,0,.343.343,0,0,0,.149-.127Z",
    transform: "translate(-331.539 -337.188)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85027",
    "data-name": "1-Caminho 85027",
    d: "M336.514,326.508l3.751-2.1-.007,5.851-3.745,2.088Z",
    transform: "translate(-330.126 -304.94)",
    fill: "none",
    stroke: "#221f20",
    strokeWidth: 1.297
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85028",
    "data-name": "1-Caminho 85028",
    d: "M341.969,329.267l1.862-1.04,0,4.243-1.859,1.036Z",
    transform: "translate(-334.637 -308.096)",
    fill: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("line", {
    id: "1-Linha_122",
    "data-name": "1-Linha 122",
    y1: 1.992,
    x2: 3.747,
    transform: "translate(6.387 24.254)",
    fill: "none",
    stroke: "#221f20",
    strokeWidth: 1.297
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85029",
    "data-name": "1-Caminho 85029",
    d: "M315.65,212.189l0,.563-.014,5.432-9.253,4.993a.17.17,0,0,1-.249-.151l-.021-5.334,0-.086a.646.646,0,0,1,.221-.409.526.526,0,0,1,.1-.072l3.8-2.172,5.127-2.935a.2.2,0,0,0,.021-.012.148.148,0,0,1,.026-.007s0,0,0,0,.012,0,.016,0a.1.1,0,0,1,.037,0,.193.193,0,0,1,.184.2",
    transform: "translate(-304.99 -211.992)",
    fill: "#3f4351"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16733",
    "data-name": "1-Grupo 16733",
    transform: "translate(-5209.44 -7548.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16681",
    "data-name": "1-Grupo 16681",
    clipPath: "url(#1-clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8272",
    "data-name": "1-Ret\\xE2ngulo 8272",
    width: 12.42,
    height: 12.447,
    transform: "matrix(0.698, -0.716, 0.716, 0.698, -4.01, 4.112)",
    fill: "url(#1-linear-gradient-5)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16734",
    "data-name": "1-Grupo 16734",
    transform: "translate(-5209.458 -7554.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16742",
    "data-name": "1-Grupo 16742",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85031",
    "data-name": "1-Caminho 85031",
    d: "M346.429,282.392l-.29.613.587.147",
    transform: "translate(-339.207 -270.199)",
    fill: "none",
    stroke: "#f3d638",
    strokeLinecap: "round",
    strokeWidth: 0.523
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85032",
    "data-name": "1-Caminho 85032",
    d: "M325.445,294.527l.29-.613-.587-.147",
    transform: "translate(-321.851 -279.604)",
    fill: "none",
    stroke: "#f3d638",
    strokeLinecap: "round",
    strokeWidth: 0.523
  }), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16687",
    "data-name": "1-Grupo 16687",
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16686",
    "data-name": "1-Grupo 16686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16685",
    "data-name": "1-Grupo 16685",
    clipPath: "url(#1-clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16684",
    "data-name": "1-Grupo 16684",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16683",
    "data-name": "1-Grupo 16683",
    clipPath: "url(#1-clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8273",
    "data-name": "1-Ret\\xE2ngulo 8273",
    width: 11.087,
    height: 9.41,
    transform: "matrix(0.891, -0.454, 0.454, 0.891, -2.306, 1.175)",
    fill: "url(#1-linear-gradient-6)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16692",
    "data-name": "1-Grupo 16692",
    transform: "translate(0.015 5.468)",
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16691",
    "data-name": "1-Grupo 16691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16690",
    "data-name": "1-Grupo 16690",
    clipPath: "url(#1-clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16689",
    "data-name": "1-Grupo 16689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16688",
    "data-name": "1-Grupo 16688",
    clipPath: "url(#1-clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8275",
    "data-name": "1-Ret\\xE2ngulo 8275",
    width: 10.962,
    height: 9.204,
    transform: "matrix(0.891, -0.454, 0.454, 0.891, -2.219, 1.131)",
    fill: "url(#1-linear-gradient-7)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85035",
    "data-name": "1-Caminho 85035",
    d: "M306.2,250.309l0,.134,9.507-5.219v-.134Z",
    transform: "translate(-306.182 -239.358)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85036",
    "data-name": "1-Caminho 85036",
    d: "M355.427,325.765l.358-.2v4.513l-.279.166Z",
    transform: "translate(-346.886 -305.898)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85037",
    "data-name": "1-Caminho 85037",
    d: "M315.711,401.379v-.321l5.933-3.279v.4Z",
    transform: "translate(-314.049 -365.602)",
    fill: "#676868"
  }), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16695",
    "data-name": "1-Grupo 16695",
    transform: "translate(7.283 29.641)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16694",
    "data-name": "1-Grupo 16694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16693",
    "data-name": "1-Grupo 16693",
    clipPath: "url(#1-clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85038",
    "data-name": "1-Caminho 85038",
    d: "M348.161,383.332l.358-.2v2.939l-.278.158Z",
    transform: "translate(-348.161 -383.135)",
    fill: "#1a1a1a"
  }))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16735",
    "data-name": "1-Grupo 16735",
    transform: "translate(-5214.045 -7520.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16698",
    "data-name": "1-Grupo 16698",
    clipPath: "url(#1-clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "1-Ret\\xE2ngulo_8279",
    "data-name": "1-Ret\\xE2ngulo 8279",
    width: 20.196,
    height: 50.779,
    transform: "translate(-5.448 0.608) rotate(-6.366)",
    fill: "url(#1-linear-gradient-8)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16736",
    "data-name": "1-Grupo 16736",
    transform: "translate(-5228.078 -7560.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16739",
    "data-name": "1-Grupo 16739",
    transform: "translate(0 0)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85040",
    "data-name": "1-Caminho 85040",
    d: "M294.3,408.654v40.714l-14.537,8.306v-40.55l14.539-8.469m.131-.229-14.805,8.626v40.814l14.805-8.418V408.425Z",
    transform: "translate(-265.598 -367.717)",
    fill: "#1a1a1a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85041",
    "data-name": "1-Caminho 85041",
    d: "M336.425,288.268a.6.6,0,0,1-.112.316.576.576,0,0,1-.254.209.258.258,0,0,1-.245-.012.237.237,0,0,1-.09-.219.656.656,0,0,1,.188-.4.049.049,0,0,1,.041-.019c.013,0,.019.013.019.029a.074.074,0,0,1-.022.049.5.5,0,0,0-.142.3.171.171,0,0,0,.255.176.482.482,0,0,0,.279-.4.174.174,0,0,0-.122-.2c-.012,0-.019-.013-.019-.03a.076.076,0,0,1,.022-.05.047.047,0,0,1,.041-.018.23.23,0,0,1,.162.259m-.308.07.011-.277a.025.025,0,0,0-.038-.026.078.078,0,0,0-.042.062l-.011.275a.026.026,0,0,0,.039.027.076.076,0,0,0,.042-.061",
    transform: "translate(-311.975 -268.158)",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85042",
    "data-name": "1-Caminho 85042",
    d: "M294.42,645.073v3.2l-14.805,8.324V653.53Z",
    transform: "translate(-265.584 -563.382)",
    fill: "gray"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85043",
    "data-name": "1-Caminho 85043",
    d: "M212.634,655.756v3.063L198.6,650.782v-3.018l12.917,7.357Z",
    transform: "translate(-198.603 -565.607)",
    fill: "gray"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85044",
    "data-name": "1-Caminho 85044",
    d: "M339.619,313.312l-3.223,1.744c-.127.069-.232-.015-.233-.188l-.012-1.4a.513.513,0,0,1,.227-.431l3.223-1.664c.127-.066.232.015.233.18l.012,1.337a.512.512,0,0,1-.227.422",
    transform: "translate(-312.328 -287.457)",
    fill: "#373737"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85045",
    "data-name": "1-Caminho 85045",
    d: "M352.615,318.516l-.38.2c-.094.05-.171-.009-.172-.132v-.006a.376.376,0,0,1,.168-.313l.38-.2c.094-.05.171.009.172.131v.006a.377.377,0,0,1-.168.312",
    transform: "translate(-325.485 -292.996)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85046",
    "data-name": "1-Caminho 85046",
    d: "M352.615,318.516l-.38.2c-.094.05-.171-.009-.172-.132v-.006a.376.376,0,0,1,.168-.313l.38-.2c.094-.05.171.009.172.131v.006A.377.377,0,0,1,352.615,318.516Z",
    transform: "translate(-325.485 -292.996)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.095
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85047",
    "data-name": "1-Caminho 85047",
    d: "M348.4,317.885l.031-.287.054-.028-.031.286Z",
    transform: "translate(-322.459 -292.6)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85048",
    "data-name": "1-Caminho 85048",
    d: "M349.07,317.121a.112.112,0,0,0-.048.014.164.164,0,0,0-.091.136c0,.039.027.046.048.048s.028.007.028.019a.056.056,0,0,1-.032.043.085.085,0,0,1-.051.013h-.007l-.007.064a.134.134,0,0,0,.06-.017.165.165,0,0,0,.093-.141.044.044,0,0,0-.046-.049c-.019,0-.031,0-.031-.018a.051.051,0,0,1,.031-.039.077.077,0,0,1,.04-.011h0Z",
    transform: "translate(-322.878 -292.228)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85049",
    "data-name": "1-Caminho 85049",
    d: "M349.927,316.668l-.042.022a.053.053,0,0,0-.028.037l-.078.288.057-.03.011-.046.069-.036.007.037.05-.026Zm-.065.207.021-.086.007-.029,0,.021.013.071Z",
    transform: "translate(-323.596 -291.854)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85050",
    "data-name": "1-Caminho 85050",
    d: "M347.493,317.83l-.051.211-.006-.034a.1.1,0,0,0-.076-.074l.05.21.057-.03.083-.313Z",
    transform: "translate(-321.596 -292.79)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85051",
    "data-name": "1-Caminho 85051",
    d: "M347.121,318.261l-.087.045v.006a.107.107,0,0,1,.132.072l-.02-.114c0-.015-.013-.016-.025-.01",
    transform: "translate(-321.326 -293.168)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85052",
    "data-name": "1-Caminho 85052",
    d: "M347.7,321.545a.482.482,0,0,1,.073-.248.127.127,0,0,0-.122.007.444.444,0,0,0-.193.37c0,.147.09.219.2.161a.339.339,0,0,0,.121-.122.182.182,0,0,1-.076-.168",
    transform: "translate(-321.677 -295.671)",
    fill: "#e20d17"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85053",
    "data-name": "1-Caminho 85053",
    d: "M348.86,321.6a.182.182,0,0,0,.076.168.481.481,0,0,0,.073-.247.183.183,0,0,0-.076-.169.481.481,0,0,0-.073.248",
    transform: "translate(-322.837 -295.731)",
    fill: "#ea610a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85054",
    "data-name": "1-Caminho 85054",
    d: "M349.4,320.561a.333.333,0,0,0-.121.122.183.183,0,0,1,.076.168.481.481,0,0,1-.073.248.127.127,0,0,0,.122-.008.445.445,0,0,0,.193-.369c0-.146-.09-.218-.2-.161",
    transform: "translate(-323.183 -295.057)",
    fill: "#f59e00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85055",
    "data-name": "1-Caminho 85055",
    d: "M341.817,321.109c.006-.025.012-.05.018-.076l.016-.066c0-.011.006-.022.009-.033a.125.125,0,0,1,.01-.025.039.039,0,0,1,.012-.014.028.028,0,0,1,.013-.005s.008,0,.009.011,0,.011,0,.016l0,.015,0,.016c0,.005,0,.01,0,.015s0,.01,0,.015,0,.01,0,.015l0,.02c0,.005,0,.011,0,.016l0,.015,0,.015,0,.016,0,.015c0,.005,0,.011,0,.016a.03.03,0,0,1-.007.021c-.007.007-.014.009-.019.005a.015.015,0,0,1,0-.011c0-.007,0-.013,0-.02s0-.014,0-.021l0-.022,0-.021,0-.02c0-.005,0-.011,0-.016l0-.021c0-.005,0-.011,0-.016a.033.033,0,0,0,0-.007c0,.008-.005.017-.007.025l-.009.038-.009.038-.017.08c0,.005,0,.01,0,.016s-.018.024-.026.02a.014.014,0,0,1-.007-.01l-.012-.041-.023-.072c0-.009-.007-.017-.01-.026v.011l0,.023v.017c0,.006,0,.012,0,.018s0,.011,0,.017l0,.019c0,.006,0,.012,0,.018s0,.012,0,.019v.018c0,.009,0,.017,0,.026a.026.026,0,0,1-.007.015.02.02,0,0,1-.015.008c-.005,0-.008-.007-.007-.015l0-.018c0-.007,0-.015,0-.022s0-.014,0-.021,0-.015,0-.022,0-.011,0-.017,0-.015,0-.023,0-.015,0-.022,0-.015,0-.022,0-.011,0-.017,0-.015,0-.023,0-.011,0-.017a.033.033,0,0,1,.007-.02.027.027,0,0,1,.013-.009l.008,0a.015.015,0,0,1,.013.011.426.426,0,0,1,.022.054l.019.056Z",
    transform: "translate(-316.924 -295.345)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85056",
    "data-name": "1-Caminho 85056",
    d: "M343.156,320.577l.015.01a.041.041,0,0,1,.012.025.094.094,0,0,1,0,.022.11.11,0,0,1-.008.036.106.106,0,0,1-.046.058l-.08.042c-.007,0-.014,0-.014-.01v-.014l0-.2a.037.037,0,0,1,.007-.023.022.022,0,0,1,.007-.006l.065-.034a.037.037,0,0,1,.034,0,.04.04,0,0,1,.02.031.088.088,0,0,1,0,.036.127.127,0,0,1-.008.025Zm-.092.147h0l.065-.034a.046.046,0,0,0,.015-.015.061.061,0,0,0,.011-.036.022.022,0,0,0-.01-.021.024.024,0,0,0-.022,0l-.031.016h-.005c-.006,0-.009-.009-.007-.019a.029.029,0,0,1,.012-.02l.025-.014a.046.046,0,0,0,.016-.02.044.044,0,0,0,0-.038.016.016,0,0,0-.024-.006l-.05.026h0Z",
    transform: "translate(-318.019 -295.004)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85057",
    "data-name": "1-Caminho 85057",
    d: "M341.864,322.194l-.169.089c-.016.009-.03,0-.033-.02a.144.144,0,0,1,0-.032.032.032,0,0,1,.015-.027c.008,0,.014,0,.014.013h0s0,.01,0,.014,0,.012.007.011h0l.01-.005.318-.167a.015.015,0,0,0,.008-.009.026.026,0,0,0,0-.009.113.113,0,0,0,0-.012.034.034,0,0,1,.012-.029c.008-.006.015,0,.016.007h0a.146.146,0,0,1,0,.031.07.07,0,0,1-.032.056l-.169.089",
    transform: "translate(-316.885 -296.268)",
    fill: "#ce1821"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85058",
    "data-name": "1-Caminho 85058",
    d: "M342.026,319.775l.123-.064c.017-.01.033,0,.037.018a.126.126,0,0,1,0,.03.033.033,0,0,1-.014.027c-.007,0-.013,0-.014-.008s0-.011,0-.017-.007-.013-.014-.008h0l-.237.123a.03.03,0,0,0-.016.025v0s0,.009,0,.013a.03.03,0,0,1-.015.024c-.008,0-.014,0-.013-.013a.166.166,0,0,1,.007-.046.067.067,0,0,1,.031-.043l.125-.065",
    transform: "translate(-317.051 -294.366)",
    fill: "#ce1821"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85059",
    "data-name": "1-Caminho 85059",
    d: "M344.372,320.045l0,.029c0,.024-.007.047-.013.071a.028.028,0,0,1-.008.016c-.005.006-.011.007-.015,0a.021.021,0,0,1,0-.008c0-.015-.007-.029-.01-.045s-.007-.036-.01-.054l0-.023a.018.018,0,0,1,.005-.015l0,0,0,0s.005,0,.006.006l.01.06.009.047v0l.012-.072c0-.017.005-.034.008-.052a.025.025,0,0,1,.01-.016c.006,0,.011,0,.011.007h0c0,.008,0,.016,0,.024l.007.037.008.037h0l.005-.036.009-.067,0-.025a.016.016,0,0,1,.006-.011.008.008,0,0,1,.009,0,.011.011,0,0,1,0,.011l-.006.045c0,.011,0,.022,0,.033l-.007.044c0,.008,0,.016,0,.025a.025.025,0,0,1-.01.016s-.009,0-.012,0a.017.017,0,0,1,0-.006l-.012-.056-.005-.025Z",
    transform: "translate(-319.07 -294.572)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85060",
    "data-name": "1-Caminho 85060",
    d: "M345.175,319.874l-.017.009-.026.014a0,0,0,0,0,0,0h0l-.007.038a.018.018,0,0,1-.011.015h0s-.006,0,0-.011h0c0-.018.007-.036.011-.054l.019-.084c0-.007,0-.014.006-.021a.018.018,0,0,1,.008-.012.014.014,0,0,1,.01,0,0,0,0,0,1,0,0l.008.022.016.051.01.033,0,.014a.018.018,0,0,1,0,.016h0s-.009.005-.011,0v0l-.01-.033m-.005-.02-.017-.055h0l-.016.073Z",
    transform: "translate(-319.731 -294.418)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85061",
    "data-name": "1-Caminho 85061",
    d: "M345.687,319.505l.009-.029.015-.055c0-.007.008-.012.012-.011l0,0a.018.018,0,0,1,0,.01l-.013.047a.4.4,0,0,1-.015.044v0a.014.014,0,0,0,0,.01c0,.015,0,.031,0,.046a.018.018,0,0,1-.007.015h0s-.008,0-.009,0,0,0,0-.006v-.045a.006.006,0,0,0,0,0,.194.194,0,0,1-.021-.038l-.011-.028a.018.018,0,0,1,0-.016l0,0c.006,0,.007,0,.01.005l.01.024.009.02.005.01",
    transform: "translate(-320.179 -294.122)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85062",
    "data-name": "1-Caminho 85062",
    d: "M353.945,319.492v.086l-.02.011,0-.213.054-.029a.031.031,0,0,1,.035,0,.043.043,0,0,1,.015.037.107.107,0,0,1-.014.053.089.089,0,0,1-.035.037l-.034.018Zm0-.1v.074l.034-.018a.049.049,0,0,0,.02-.022.065.065,0,0,0,.008-.03.026.026,0,0,0-.008-.021.017.017,0,0,0-.02,0l-.034.018Z",
    transform: "translate(-327.024 -294.065)",
    fill: "#383e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85063",
    "data-name": "1-Caminho 85063",
    d: "M354.613,319.385a.033.033,0,0,1,.036,0,.044.044,0,0,1,.013.037v.09l-.019.011v-.02h0a.078.078,0,0,1-.034.043.029.029,0,0,1-.03,0,.032.032,0,0,1-.012-.029.077.077,0,0,1,.012-.043.087.087,0,0,1,.034-.032.045.045,0,0,1,.03-.007v-.006a.022.022,0,0,0-.009-.02.019.019,0,0,0-.02,0,.063.063,0,0,0-.027.034l-.018-.006a.1.1,0,0,1,.044-.052m-.025.12a.015.015,0,0,0,.007.014.017.017,0,0,0,.016,0,.058.058,0,0,0,.023-.025.07.07,0,0,0,.01-.035.029.029,0,0,0-.027,0,.057.057,0,0,0-.021.019.044.044,0,0,0-.008.025",
    transform: "translate(-327.554 -294.095)",
    fill: "#383e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85064",
    "data-name": "1-Caminho 85064",
    d: "M355.241,318.954l-.066.246-.021.011.025-.087-.046-.112.022-.012.033.087h0l.03-.121Z",
    transform: "translate(-328.022 -293.744)",
    fill: "#383e41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85065",
    "data-name": "1-Caminho 85065",
    d: "M353.157,320.217l-.086.046v.047l.049-.026a.108.108,0,0,1-.018.048v.029l.03-.014a.213.213,0,0,0,.026-.1.161.161,0,0,0,0-.025",
    transform: "translate(-326.318 -294.788)",
    fill: "#1787f2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85066",
    "data-name": "1-Caminho 85066",
    d: "M352.718,320.876h0a.086.086,0,0,1-.031.028.034.034,0,0,1-.052-.023l-.025.008,0,.04a.055.055,0,0,0,.082.024.155.155,0,0,0,.06-.062Z",
    transform: "translate(-325.933 -295.333)",
    fill: "#18a74f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85067",
    "data-name": "1-Caminho 85067",
    d: "M352.582,320.528a.123.123,0,0,1,0-.025l-.008-.028-.022.012a.2.2,0,0,0-.009.06.12.12,0,0,0,.01.05l.03-.048a.078.078,0,0,1,0-.022",
    transform: "translate(-325.883 -295.002)",
    fill: "#fcb92c"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85068",
    "data-name": "1-Caminho 85068",
    d: "M352.68,319.86a.189.189,0,0,0-.081.111l.03.015a.119.119,0,0,1,.051-.078.032.032,0,0,1,.035,0l.026-.049a.056.056,0,0,0-.061,0",
    transform: "translate(-325.928 -294.485)",
    fill: "#fb423a"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85069",
    "data-name": "1-Caminho 85069",
    d: "M352.754,313.156l-.577.3a.192.192,0,0,0-.026.016.085.085,0,0,0-.023.028.1.1,0,0,0-.012.038.285.285,0,0,0,0,.036l0,.436a.231.231,0,0,0,0,.035.038.038,0,0,0,.012.025.024.024,0,0,0,.023,0,.153.153,0,0,0,.027-.012l.577-.3a.157.157,0,0,0,.026-.016.088.088,0,0,0,.023-.028.111.111,0,0,0,.012-.037.282.282,0,0,0,0-.036l0-.432a.287.287,0,0,0,0-.035.039.039,0,0,0-.012-.025.025.025,0,0,0-.023,0,.165.165,0,0,0-.027.012",
    transform: "translate(-325.527 -288.939)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85070",
    "data-name": "1-Caminho 85070",
    d: "M352.825,313.278a.143.143,0,0,1,.024-.011.017.017,0,0,1,.015,0,.027.027,0,0,1,.008.016.228.228,0,0,1,0,.031l0,.432a.252.252,0,0,1,0,.032.07.07,0,0,1-.007.024.059.059,0,0,1-.015.019.164.164,0,0,1-.024.014l-.577.3h0a.145.145,0,0,1-.024.011.017.017,0,0,1-.015,0,.025.025,0,0,1-.008-.016.232.232,0,0,1,0-.032l0-.436a.143.143,0,0,1,0-.046.067.067,0,0,1,.012-.022.091.091,0,0,1,.032-.022Z",
    transform: "translate(-325.598 -289.042)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85071",
    "data-name": "1-Caminho 85071",
    d: "M353.1,315.534a.09.09,0,0,0,.009-.042.077.077,0,0,0-.026.031.085.085,0,0,0-.009.041.06.06,0,0,0,.026-.03",
    transform: "translate(-326.325 -290.882)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85072",
    "data-name": "1-Caminho 85072",
    d: "M352.781,315.8c-.014.006-.026.025-.033.028s-.017,0-.029,0a.088.088,0,0,0-.036.048.134.134,0,0,0,.012.112c.007.011.016.022.028.015s.015-.017.028-.024.017,0,.029-.006a.085.085,0,0,0,.026-.043.235.235,0,0,0,.012-.039s-.023,0-.024-.035a.1.1,0,0,1,.019-.055.025.025,0,0,0-.032-.007",
    transform: "translate(-325.992 -291.137)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85073",
    "data-name": "1-Caminho 85073",
    d: "M353.713,315.182c.031-.016.053,0,.054.043a.112.112,0,0,1-.053.1l-.035.018v.074l-.025.013,0-.216Zm-.034.132.029-.015a.065.065,0,0,0,.034-.061c0-.027-.013-.036-.034-.025l-.029.015Z",
    transform: "translate(-326.8 -290.621)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85074",
    "data-name": "1-Caminho 85074",
    d: "M354.354,315.3a.08.08,0,0,1,.043-.069l.032-.019V315.2c0-.017-.009-.023-.024-.016a.047.047,0,0,0-.024.036l-.023.012a.09.09,0,0,1,.048-.074c.028-.015.047,0,.047.027v.108l-.023.012v-.026h0a.085.085,0,0,1-.037.048c-.023.012-.039,0-.039-.027m.076-.054v-.012l-.029.017a.042.042,0,0,0-.022.035c0,.014.009.018.022.011a.061.061,0,0,0,.03-.052",
    transform: "translate(-327.379 -290.603)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85075",
    "data-name": "1-Caminho 85075",
    d: "M355,314.97v-.026l.008,0a.042.042,0,0,0,.021-.033l0-.011-.044-.135.026-.014.031.112h0l.029-.143.025-.013-.042.188c-.01.043-.021.062-.045.074l-.01,0",
    transform: "translate(-327.898 -290.229)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85076",
    "data-name": "1-Caminho 85076",
    d: "M342.487,323.383a.1.1,0,0,1-.043.083l-.648.349c-.024.013-.044,0-.044-.037l-.005-.579a.1.1,0,0,1,.043-.083l.649-.343c.024-.013.044,0,.044.036Z",
    transform: "translate(-316.955 -296.898)",
    fill: "#3471c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16702",
    "data-name": "1-Grupo 16702",
    transform: "translate(24.791 26.202)",
    opacity: 0.15,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16701",
    "data-name": "1-Grupo 16701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16700",
    "data-name": "1-Grupo 16700",
    clipPath: "url(#1-clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85077",
    "data-name": "1-Caminho 85077",
    d: "M341.782,325.342l-.005-.578a.1.1,0,0,1,.043-.083l-.031.016a.1.1,0,0,0-.043.083l.005.579c0,.033.02.049.044.036l.031-.017c-.024.013-.044,0-.044-.036",
    transform: "translate(-341.746 -324.681)",
    fill: "#202121"
  }))))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85078",
    "data-name": "1-Caminho 85078",
    d: "M342.376,325.98l.022-.012-.011-.033Z",
    transform: "translate(-317.475 -299.517)",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85079",
    "data-name": "1-Caminho 85079",
    d: "M343.057,326.47v.018l.037-.02v.019l-.037.02v.021l.041-.022.019-.039-.018-.019Z",
    transform: "translate(-318.039 -299.94)",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85080",
    "data-name": "1-Caminho 85080",
    d: "M344.66,324.724l-.012.045.023-.012Z",
    transform: "translate(-319.354 -298.514)",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85081",
    "data-name": "1-Caminho 85081",
    d: "M343.552,326.27v-.078l-.026.052Z",
    transform: "translate(-318.426 -299.728)",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85082",
    "data-name": "1-Caminho 85082",
    d: "M343.8,326.129c0-.008-.005-.01-.011-.006l-.021.011v.025l.022-.012a.019.019,0,0,0,.01-.018",
    transform: "translate(-318.63 -299.67)",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85083",
    "data-name": "1-Caminho 85083",
    d: "M344.226,325.915a.021.021,0,0,0,0-.011c0-.006,0-.008,0-.008l-.008,0-.02.011v.022l.02-.011.008-.006",
    transform: "translate(-318.982 -299.484)",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85084",
    "data-name": "1-Caminho 85084",
    d: "M342.6,324.156v.016l-.006-.013-.047.025v.016l-.006-.013-.064.034a.089.089,0,0,0-.028.023v-.008l-.045.024h0v.007a.019.019,0,0,0-.019,0l-.161.086-.011.04-.011-.028-.036.019-.015.008v.016l-.005-.014h0l-.043.023-.019.075-.022.082v0h0l.051-.027h0v0l.006-.024.013-.007.006.019.058-.031h0v-.015l.005.014.029-.015,0-.019v.015h0l.023-.012.115-.061h0v-.036h0s0,0,0,0v.03l.072-.038v-.008a.044.044,0,0,0,.027-.006l.03-.016.006-.025.014-.007.006.019.058-.031v-.02l.009.016h0l.044-.023v-.134Zm-.338.3-.01.005-.006,0v-.072h0l-.023.085h0l-.005,0-.009,0-.025-.063v.076l-.034.018-.007-.017-.034.018-.007.024-.017.009.029-.112.025-.013.029.077v-.092l.006,0,.02-.011h0l.013.031.009.023v0l.019-.077.027-.014Zm.068-.112-.039.021v.018l.038-.02v.019l-.038.02v.019l.039-.021v.02l-.056.03v-.1l.056-.03Zm.072,0h0a.022.022,0,0,1,0,.014h0v.021l-.015.008v-.011a.034.034,0,0,0,0-.018h0s0,0-.009,0l-.018.01v.034l-.017.009v-.1l.038-.02c.009,0,.015-.008.02-.006s.008.006.008.017a.048.048,0,0,1-.012.032.008.008,0,0,1,.006,0m.034.022-.017.009v-.1l.017-.009Zm.195-.1-.022.012-.033-.055v.06h0v.012l-.017.009h0l-.017.009-.006-.017-.035.019-.006.025-.019.01c-.008,0-.018.007-.024,0s-.009-.014-.009-.032a.1.1,0,0,1,.009-.043.053.053,0,0,1,.025-.024l.016-.008v.02l-.016.008a.031.031,0,0,0-.013.012.057.057,0,0,0,0,.024c0,.011,0,.017.005.021s.007,0,.012,0l.007,0,.022-.087.01-.005.015-.008.029.077V324.2l.025-.013.03.052v-.067l.017-.009Z",
    transform: "translate(-317.218 -298.025)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85085",
    "data-name": "1-Caminho 85085",
    d: "M343.816,325.18v0a.022.022,0,0,0,0-.011h0a0,0,0,0,0,0,0l-.008,0-.02.011v.022l.02-.011.008-.006h0",
    transform: "translate(-318.642 -298.878)",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85086",
    "data-name": "1-Caminho 85086",
    d: "M343.362,325.023a.052.052,0,0,0-.005-.023v-.061h0v0l-.048.026a.057.057,0,0,0-.014.016v-.008l-.046.024a.051.051,0,0,0-.02.019V325l-.082.044v.008c-.006,0-.017,0-.022,0l-.054.029v.008c-.005,0-.017,0-.023,0l-.06.032-.014.028-.013-.014,0,0-.007,0-.079.042v.138l.088-.047.014-.028.013.013h0l.051-.027h0v-.031l.005,0a.082.082,0,0,0,.023-.016v.037l.045-.024v-.035h0s0,0,0,0v.032l.136-.073a.06.06,0,0,0,.023-.02v.008l.043-.023a.067.067,0,0,0,.024-.02.085.085,0,0,0,.015-.045h0v0m-.315.16-.02.011v.036l-.033.017-.019-.02h0l-.022.043-.064.034v-.1l.065-.035.018.017,0,0h0l.021-.043.053-.028c.01-.005.022-.008.026,0a.042.042,0,0,1,0,.009.049.049,0,0,1-.029.048m.1-.055a.032.032,0,0,1,0,.016v.019l-.017.009v-.012c0-.005,0-.015,0-.018s-.006,0-.012,0l-.018.01v.035l-.017.009v-.1l.038-.02c.008,0,.015-.008.02-.007s.009.006.009.017a.049.049,0,0,1-.012.032c.005,0,.008,0,.009,0m.068-.077-.039.021v.018l.038-.02v.019l-.038.02v.019l.039-.021v.02l-.056.03v-.1l.056-.03Zm.043.054-.032.017v-.02l.032-.017a.014.014,0,0,0,.007-.006.021.021,0,0,0,0-.008.008.008,0,0,0,0-.006s0,0-.006,0-.035.019-.035-.011a.046.046,0,0,1,.024-.041l.033-.018v.023l-.031.017-.007.005a.012.012,0,0,0,0,.008s0,0,0,0l.006,0,.009,0c.009,0,.015-.005.019,0a.024.024,0,0,1,.005.018.046.046,0,0,1-.026.044m.086-.056a.05.05,0,0,1-.021.021l-.032.017v-.02l.032-.017a.013.013,0,0,0,.007-.007.021.021,0,0,0,0-.008.008.008,0,0,0,0-.006s0,0-.006,0-.035.019-.035-.011a.048.048,0,0,1,.019-.038l.005,0,.033-.018v.023l-.022.012-.008,0h0l-.007.005a.018.018,0,0,0,0,.008s0,0,0,0l.006,0h0l.008,0,.011,0s.012,0,.014.014v0a.05.05,0,0,1-.006.024",
    transform: "translate(-317.885 -298.688)",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "1-Linha_123",
    "data-name": "1-Linha 123",
    x2: 0.013,
    y2: 1.517,
    transform: "translate(24.545 25.61)",
    fill: "none",
    stroke: "#f5d73d",
    strokeLinecap: "round",
    strokeWidth: 0.193
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85087",
    "data-name": "1-Caminho 85087",
    d: "M337.153,326.994c-.008-.007-.021,0-.029.016a.036.036,0,0,0,0,.04.036.036,0,0,1,0,.04c-.008.015-.007.033,0,.04s.021,0,.029-.015a.108.108,0,0,0,0-.121",
    transform: "translate(-313.129 -300.389)",
    fill: "#f5d73d"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85088",
    "data-name": "1-Caminho 85088",
    d: "M337.566,326.188c-.008-.007-.021,0-.029.015a.037.037,0,0,0,0,.041h0a.217.217,0,0,1,0,.242.036.036,0,0,0,0,.041c.008.007.021,0,.029-.015h0a.289.289,0,0,0,0-.323",
    transform: "translate(-313.469 -299.723)",
    fill: "#f5d73d"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85089",
    "data-name": "1-Caminho 85089",
    d: "M338.059,325.606a.287.287,0,0,0-.08-.22c-.008-.007-.021,0-.029.014a.037.037,0,0,0,0,.04h0a.4.4,0,0,1,0,.443.037.037,0,0,0,0,.041c.008.007.021,0,.029-.015h0a.666.666,0,0,0,.076-.3",
    transform: "translate(-313.811 -299.059)",
    fill: "#f5d73d"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85090",
    "data-name": "1-Caminho 85090",
    d: "M338.4,325.311a.647.647,0,0,0-.006-.724c-.008-.007-.021,0-.029.016a.036.036,0,0,0,0,.04.575.575,0,0,1,.006.644.035.035,0,0,0,0,.04c.008.006.021,0,.029-.015",
    transform: "translate(-314.155 -298.399)",
    fill: "#f5d73d"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16705",
    "data-name": "1-Grupo 16705",
    transform: "translate(24.026)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16704",
    "data-name": "1-Grupo 16704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16703",
    "data-name": "1-Grupo 16703",
    clipPath: "url(#1-clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85091",
    "data-name": "1-Caminho 85091",
    d: "M337.327,174.967l2.726-1.563a.073.073,0,0,1,.11.062l0,2.97-2.833,1.516Z",
    transform: "translate(-337.327 -173.394)",
    fill: "#f4af40"
  }))))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85092",
    "data-name": "1-Caminho 85092",
    d: "M315.708,240.758l-9.508,5.167v-.677l9.508-5.077Z",
    transform: "translate(-287.565 -228.605)",
    fill: "#e7e7e7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85093",
    "data-name": "1-Caminho 85093",
    d: "M306.92,267.97l-.707.38v-.677l.707-.38Z",
    transform: "translate(-287.575 -251.03)",
    fill: "#b9b9ba"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85094",
    "data-name": "1-Caminho 85094",
    d: "M311.414,265.548l-.708.388v-.677l.708-.373Z",
    transform: "translate(-291.291 -249.041)",
    fill: "#b9b9ba"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85095",
    "data-name": "1-Caminho 85095",
    d: "M315.758,263.164l-.707.389v-.663l.707-.38Z",
    transform: "translate(-294.883 -247.076)",
    fill: "#b9b9ba"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16708",
    "data-name": "1-Grupo 16708",
    transform: "translate(21.333 11.337)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16707",
    "data-name": "1-Grupo 16707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16706",
    "data-name": "1-Grupo 16706",
    clipPath: "url(#1-clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85096",
    "data-name": "1-Caminho 85096",
    d: "M325.679,239.5l-3.9,2.186v-.663l3.9-2.177Z",
    transform: "translate(-321.78 -238.851)",
    fill: "#e7e7e7"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16711",
    "data-name": "1-Grupo 16711",
    transform: "translate(21.142 11.916)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16710",
    "data-name": "1-Grupo 16710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16709",
    "data-name": "1-Grupo 16709",
    clipPath: "url(#1-clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85097",
    "data-name": "1-Caminho 85097",
    d: "M321.739,242.668l-.868.487a.131.131,0,0,1-.2-.114v-.18a.131.131,0,0,1,.068-.115l1-.55Z",
    transform: "translate(-320.676 -242.196)",
    fill: "#e7e7e7"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16714",
    "data-name": "1-Grupo 16714",
    transform: "translate(22.205 10.24)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16713",
    "data-name": "1-Grupo 16713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16712",
    "data-name": "1-Grupo 16712",
    clipPath: "url(#1-clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85098",
    "data-name": "1-Caminho 85098",
    d: "M329.818,232.988l-3,1.675v-.482l2.978-1.652a.079.079,0,0,1,.118.069v.232a.18.18,0,0,1-.092.158",
    transform: "translate(-326.815 -232.519)",
    fill: "#565d72"
  }))))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85099",
    "data-name": "1-Caminho 85099",
    d: "M343.355,248.4l-.707.389v-.663l.707-.38Z",
    transform: "translate(-317.7 -234.871)",
    fill: "#b9b9ba"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85100",
    "data-name": "1-Caminho 85100",
    d: "M350.8,241.326l-1.943,1.036v-.608l1.943-1.037Z",
    transform: "translate(-322.833 -229.057)",
    fill: "#417158"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16717",
    "data-name": "1-Grupo 16717",
    transform: "translate(24.238 10.242)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16716",
    "data-name": "1-Grupo 16716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_16715",
    "data-name": "1-Grupo 16715",
    clipPath: "url(#1-clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_85101",
    "data-name": "1-Caminho 85101",
    d: "M339.554,232.98l-1,.563v-.482l.94-.519a.083.083,0,0,1,.123.072v.263a.117.117,0,0,1-.06.1",
    transform: "translate(-338.551 -232.532)",
    fill: "#e7e7e7"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_13368",
    "data-name": "1-Grupo 13368",
    transform: "translate(488.995 62.911)"
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_13359",
    "data-name": "1-Grupo 13359",
    transform: "translate(23.45 80.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78022",
    "data-name": "1-Caminho 78022",
    d: "M1714.767,1478.774c-.846-.847-.522-3.646,1.709-3.675,1.626-.021,4.158,3.327,6.089,4.642a3.018,3.018,0,0,1-.533,2.48,2.771,2.771,0,0,1-2.684.423C1717.754,1482.268,1715.76,1479.764,1714.767,1478.774Z",
    transform: "translate(-1714.338 -1475)",
    fill: "#8c96a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78023",
    "data-name": "1-Caminho 78023",
    d: "M1714.692,1477.818c-.582-.573-.537-2.616,2.074-2.755,1.625-.086,3.793,2.407,5.723,3.72a3.012,3.012,0,0,1-.532,2.479,2.762,2.762,0,0,1-2.683.427C1717.679,1481.309,1715.692,1478.8,1714.692,1477.818Z",
    transform: "translate(-1714.263 -1475.061)",
    fill: "#001531"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_13360",
    "data-name": "1-Grupo 13360",
    transform: "translate(5.614 82.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78024",
    "data-name": "1-Caminho 78024",
    d: "M1707.576,1479.94c-.692-.544-.786-3.254,2.015-3.722,1.741-.29,6.547,1.537,8.771,2.715a3.286,3.286,0,0,1-.3,2.739,3.016,3.016,0,0,1-2.845.785C1713.453,1482.244,1708.762,1480.877,1707.576,1479.94Z",
    transform: "translate(-1707.168 -1475.935)",
    fill: "#afb4be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78025",
    "data-name": "1-Caminho 78025",
    d: "M1707.666,1479.292c-.68-.536-.853-2.7,1.895-3.162,1.712-.285,6.513,1.014,8.7,2.174a3.233,3.233,0,0,1-.3,2.689,2.967,2.967,0,0,1-2.794.769C1713.439,1481.553,1708.83,1480.213,1707.666,1479.292Z",
    transform: "translate(-1707.058 -1476.091)",
    fill: "#001531"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78026",
    "data-name": "1-Caminho 78026",
    d: "M1711.349,1463.517l15.5-2.01c.452,3.2,1.015,12.664,1.316,21.991.226,4.032,2.912,12.66,2.821,17.155-.038,1.771-5.405,1.706-5.784-.131l-4.233-14.578c-.055-.47-.089-.943-.1-1.416l-1.557-9.539s-2.433,8.162-3.333,11.75c0,0,.164,14.071.149,15.492-.017,1.874-4.562,1.173-4.674.058a173.759,173.759,0,0,1-2.7-18.394C1708.376,1480.716,1710.369,1468.257,1711.349,1463.517Z",
    transform: "translate(-1699.264 -1416.81)",
    fill: "#273c5d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_13367",
    "data-name": "1-Grupo 13367",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_13366",
    "data-name": "1-Grupo 13366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_13365",
    "data-name": "1-Grupo 13365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_13364",
    "data-name": "1-Grupo 13364",
    transform: "translate(10.822)"
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_13361",
    "data-name": "1-Grupo 13361",
    transform: "translate(1.352 13.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78027",
    "data-name": "1-Caminho 78027",
    d: "M1719.184,1456.784a13.368,13.368,0,0,1-2.666-.849c-.53-.429-.749-.815-1.231-1.258a3.318,3.318,0,0,0-2.227-.762c-.206.016-.467.076-.5.289a1.66,1.66,0,0,1,.361.306,1.979,1.979,0,0,1-1.259.11,1.444,1.444,0,0,0-1.652.911,2.356,2.356,0,0,0-.188,1.2c.084.813.793,1.11,1.418,1.383a9.7,9.7,0,0,0,2.9.528c.3.039,2.054.7,3.959,1.39C1718.409,1458.938,1718.8,1457.858,1719.184,1456.784Z",
    transform: "translate(-1709.805 -1442.247)",
    fill: "#f4bd98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78028",
    "data-name": "1-Caminho 78028",
    d: "M1718.187,1458.259c.1.439.6,5.015.6,5.015l-5.1-.364a4.894,4.894,0,0,0-2.034,3.366c1.172.624,6.47,1.858,9.76,2.268a2.686,2.686,0,0,0,2.938-2.38,39.633,39.633,0,0,0,.208-7.665c-.526-5.013-.853-8.533-4.228-9.035a2.392,2.392,0,0,0-2.047.777,4.255,4.255,0,0,0-.7,2.266A19.79,19.79,0,0,0,1718.187,1458.259Z",
    transform: "translate(-1707.058 -1449.447)",
    fill: "#475563"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78029",
    "data-name": "1-Caminho 78029",
    d: "M1725.908,1482.663c-2.421,4.019-11.853,4.111-14.954,1.978a1.457,1.457,0,0,1-.59-1.156c-.193-5.478-2.537-25.131.26-27.718,2.93-2.713,8.233-5.809,12.269-6.254a2.613,2.613,0,0,1,2.808,2.119c1.378,6.78.415,24.655.391,30.313A1.356,1.356,0,0,1,1725.908,1482.663Z",
    transform: "translate(-1709.262 -1436.183)",
    fill: "#475563"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_13363",
    "data-name": "1-Grupo 13363",
    transform: "translate(3.013)"
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78030",
    "data-name": "1-Caminho 78030",
    d: "M1718.987,1453.354a1.025,1.025,0,0,1-.134-.418c-.026-.348,0-.709-.005-1.055a11.656,11.656,0,0,0-.04-1.433c-.092-.661-.878-.517-1.37-.765a14.173,14.173,0,0,0-2.594-.8,1.955,1.955,0,0,1-.435-.155,3.71,3.71,0,0,0-.54-.344c-.156-.052-.323-.057-.482-.115a8.544,8.544,0,0,1-1.14-.562,44.112,44.112,0,0,1,.393,7.221l-1.465,1.228c-.079.708,4.01,1.16,7.266-.816a1.77,1.77,0,0,0,.83-.977C1719.39,1453.918,1719.151,1453.659,1718.987,1453.354Z",
    transform: "translate(-1709.43 -1439.07)",
    fill: "#f4bd98"
  })), /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78031",
    "data-name": "1-Caminho 78031",
    d: "M1712.944,1453.84c-.294-.138,4.156-4,3.853-4.157-.821-.407-5.195-1.912-5.192-1.973a46.571,46.571,0,0,1,.344,7.33A2.937,2.937,0,0,0,1712.944,1453.84Z",
    transform: "translate(-1708.788 -1439.07)",
    fill: "#b79076",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78032",
    "data-name": "1-Caminho 78032",
    d: "M1710.885,1450.011c.11,1.19.221,2.381.358,3.568.128,1.119.375,2.208.5,3.317a1.889,1.889,0,0,0,.155.656,1.59,1.59,0,0,0,.519.547c1.005.729,1.908.517,3.057.4a7.883,7.883,0,0,0,2.746-.844,2.41,2.41,0,0,0,1.617-2.478,15.634,15.634,0,0,0-1.791-6.6,6.93,6.93,0,0,0-.9-1.641,5.808,5.808,0,0,0-3.536-1.719,1.955,1.955,0,0,0-2.836,1.994A18.235,18.235,0,0,0,1710.885,1450.011Z",
    transform: "translate(-1710.053 -1443.277)",
    fill: "#f4bd98"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "1-Grupo_13362",
    "data-name": "1-Grupo 13362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78033",
    "data-name": "1-Caminho 78033",
    d: "M1710.487,1447.782c.09.841.531,1.779.675,2.493a1.87,1.87,0,0,0,.154.449,7.907,7.907,0,0,1,.836,1.649c.035.167-.135,1.794.008,1.8s.534.089.662.01c.308-.18.153-.261.272-.565.348-.9.995-1.381,1.368-.235a5.731,5.731,0,0,1,0,1.689c.042,1.265.375,2.216,1.579,2.445a5.75,5.75,0,0,0,2.34-.03,5.086,5.086,0,0,0,3.707-4.518,12.7,12.7,0,0,0-.094-5.75c-.544-1.7-2.588-2.579-4.206-2.644a8.772,8.772,0,0,0-5.2.53c-.713.366-1.8,1.03-2.051,1.876A2.106,2.106,0,0,0,1710.487,1447.782Z",
    transform: "translate(-1710.473 -1444.403)",
    fill: "#24150c"
  }))))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78034",
    "data-name": "1-Caminho 78034",
    d: "M1705.172,1452.619a.451.451,0,0,1-.139-.376c.087-.783,2.251.735,2.582.9.708.358.635,1,.989,1.594.351.583,1.117.881,1.211,1.628.127.983-.81,1.733-1.572,2.349a.525.525,0,0,1-.868-.1,13.848,13.848,0,0,1-.684-1.263,5.1,5.1,0,0,0-.552-.693c-.323-.376-1.094-.428-1.214-.977-.1-.45.294-.909.48-1.275.216-.429.711-.774.381-1.289C1705.658,1452.919,1705.354,1452.8,1705.172,1452.619Z",
    transform: "translate(-1704.91 -1432.116)",
    fill: "#f4bd98"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_78035",
    "data-name": "1-Caminho 78035",
    d: "M1712.609,1458.659l-4.057-3.089c-1.178-1.344-3.348,1.142-3.047,2.354.3,1.565,7.753,9.372,8.74,8.235,2.686-3.1,7.6-11.342,5.141-13.819a2.369,2.369,0,0,0-2.092-.624,3.915,3.915,0,0,0-1.828,1.408A32.727,32.727,0,0,0,1712.609,1458.659Z",
    transform: "translate(-1704.067 -1432.7)",
    fill: "#475563"
  }))))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "1-Caminho_84936",
    "data-name": "1-Caminho 84936",
    d: "M1.713-7.954l30.7,18.339v4.895L1.747-.594Z",
    transform: "translate(431.227 148.273)",
    fill: "#082143"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreetMessage);
export default __webpack_public_path__ + "static/media/street-message.727aa2bdf2ac7822406ff036b6b66e1c.svg";
export { ForwardRef as ReactComponent };